module.exports = __webpack_public_path__ + "img/icon_error.b9cf79be.svg";